export const aplicativo = {
  nome: 'Constel/Shop',
  versao: '6.6.19',
};
